import EnvironmentHelper from '../EnvironmentHelper/EnvironmentHelper';
import { ApiHelper } from './ApiHelper';
import { getOpenApiToken } from '@/functions/getOpenApiToken';

export class BombBombApiHelper extends ApiHelper {
  constructor(authToken = getOpenApiToken(), allowApiKeyAuthFallback = false) {
    const baseConfig = {
      headers: new Headers({
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json; charset=utf-8',
      }),
    };
    /**
     * The EnvironmentHelper needs to have already had its environment set before this class is
     * instantiated, so that the correct API URL is used.
     */
    super(EnvironmentHelper.getApiUrl(), baseConfig, allowApiKeyAuthFallback);
  }
}
